import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import moment from 'moment';
import { Popover } from 'primeng/popover';
import readXlsxFile from 'read-excel-file';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { UserModel } from 'src/app/models/authentication/user.model';
import { InvoiceImportModel } from 'src/app/models/imports/invoice-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-invoices-import',
  templateUrl: './invoices-import.component.html',
  styleUrls: ['./invoices-import.component.scss'],
  standalone: false
})
export class InvoicesImportComponent implements OnInit {
  @ViewChild('information') informationPopover!: Popover;

  formImport: FormGroup = new FormGroup({});
  branchCode: number | null = null;
  branchId: number = 0;
  companyCode: number | null = null;
  companyId: number | null = null;
  enterpriseCode: number | null = null;
  enterpriseId: number = 0;
  eventFile: any;
  errorInvoice: number = 0;
  invoiceAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  filters: ColumnResponseModel[] = [];
  listArticles: any[] = [];
  listBranches: any[] = [];
  listClasses: any[] = [
    { label: "Facturas", value: 1 },
    { label: "Cuentas Cobro", value: 6 }
  ];
  listCompanies: any[] = [];
  listEnterprises: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = 'Ningún archivo seleccionado.';
  nameWindow: string = 'Importación Facturas';
  isOpened: string | undefined = undefined;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  url: string = "invoices-import";
  userAuthenticated: UserModel = new UserModel();
  visibleTxt: boolean = false;

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private invoiceService: InvoiceService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.getCompanies();
  }

  ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    this.getPermission();
    this.validateForm();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.invoiceAlerts || this.invoiceAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.invoiceService.exportImportErrors(this.invoiceAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionFacturas_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.invoiceService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaFacturas.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  async getCompanies() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),
      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getAllLists(companyId: number) {
    try {
      const [articles] = await Promise.all([
        firstValueFrom(this.articleService.getAllArticlesByCompanyForSelectAsync(companyId))
      ]);
      this.listArticles = articles;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number) {
    if (branchId != null && branchId != 0) {
      this.branchId = branchId;
      const branch = this.listBranches.find(x => x.value == branchId);
      this.branchCode = branch.code;
      this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
    } else {
      this.branchCode = null;
      this.branchId = 0;
      this.listEnterprises = [];
    }
  }

  async getCompany(companyId: number | null) {
    if (companyId != null && companyId != 0) {
      this.companyId = companyId;
      const company = this.listCompanies.find(x => x.value == companyId);
      this.companyCode = company.code;
      this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
      await this.getAllLists(companyId);
    } else {
      this.companyId = null;
      this.companyCode = null;
      this.listBranches = [];
      this.listEnterprises = [];
      this.listArticles = [];
      this.validateForm();
    }
  }

  async getEnterprise(enterpriseId: number | null) {
    if (enterpriseId != null && enterpriseId != 0) {
      this.enterpriseId = enterpriseId;
      const enterprise = this.listEnterprises.find(x => x.value == enterpriseId);
      this.enterpriseCode = enterprise.code;
    } else {
      this.enterpriseId = 0;
      this.companyCode = null;
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por tipo de impuesto.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
  }

  importInvoices() {
    this.invoiceAlerts = [];
    this.errorInvoice = 0;
    this.visibleTxt = false;
    if (this.formImport.valid) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<InvoiceImportModel>();
      let row: InvoiceImportModel;
      let counter: number = 1, bussinessDocumentsClassId: number, bussinessDocumentsTypeCode: number, invoiceConsecutive: number, dateInvoice: Date, dateExpiration: Date, invoiceWalletTypeCode: number | null, clientDocument: string,
        clientDocument2: string | null, costCenterCode: number | null, sellerDocument: string | null, cufe: string | null, swSelfRetainer: boolean, swIcaSelfRetainer: boolean, subtotalValue: number,
        discountValue: number, ivaValue: number, totalValue: number, reteIvaValue: number, reteFuenteValue: number, reteIcaValue: number, valueToPay: number,
        paymentValue: number, debitNotesValue: number, creditNotesValue: number, residueValue: number, updateDetails: boolean, conceptInvoicingCode: number | null,
        storeCode: number | null, valueConcept: number | null, ivaValueConcept: number | null, reteFuenteValueConcept: number | null, reteIcaValueConcept: number | null,
        discountValueConcept: number | null, debitNotesValueConcept: number | null, creditNotesValueConcept: number | null, articleId: number | null, updateInvoicesZero: boolean, dateInvoicePdf: Date, dateInvoiceSend: Date;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar`);
            return;
          }
          rows.splice(0, 1);

          bussinessDocumentsClassId = this.formImport.get("bussinessDocumentsClassId")?.value;
          articleId = this.formImport.get("articleId")?.value;
          if (articleId == 0) articleId = null;
          updateInvoicesZero = this.formImport.get("updateInvoicesZero")?.value;

          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            //A. Código Compañía:
            const companyCode = parseFloat(element[0] as string);
            if (isNaN(companyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El código de la compañía no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }
            if (companyCode != this.companyCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. La compañía del archivo no es igual a la compañía seleccionada.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Sucursal:
            const branchCode = parseFloat(element[1] as string);
            if (isNaN(branchCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código de la sucursal no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }
            if (branchCode != this.branchCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna B, Fila ${counter}. La sucursal del archivo no es igual a la sucursal seleccionada.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //C. Código Empresa:
            const enterpriseCode = parseFloat(element[2] as string);
            if (isNaN(enterpriseCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El código de la empresa no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }
            if (enterpriseCode != this.enterpriseCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. La empresa del archivo no es igual a la empresa seleccionada.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //D. Tipo de Documento Comercial:
            bussinessDocumentsTypeCode = parseFloat(element[3] as string);
            if (isNaN(bussinessDocumentsTypeCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. El tipo de documento comercial no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //E. Número de Factura:
            invoiceConsecutive = parseFloat(element[4] as string);
            if (isNaN(invoiceConsecutive)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna E. El número de factura no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //F. Fecha:
            const dateInvoiceString = element[5] as string;
            if (dateInvoiceString == null || dateInvoiceString == "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna F. El campo de fecha factura es obligatorio.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }
            //Convierte fecha de string a Date
            dateInvoice = moment(dateInvoiceString, 'DD/MM/YYYY').toDate();

            if (!moment(dateInvoiceString, 'DD/MM/YYYY').isValid()) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna F. El campo de fecha factura no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //G. Fecha Vencimiento:
            const dateExpirationString = element[6] as string;
            if (dateExpirationString == null || dateExpirationString == "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna G. El campo de fecha vencimiento es obligatorio.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //Convierte fecha de string a Date
            dateExpiration = moment(dateExpirationString, 'DD/MM/YYYY').toDate();

            if (!moment(dateExpirationString, 'DD/MM/YYYY').isValid()) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna G. El campo de fecha vencimiento no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //H. Tipo Cartera:
            invoiceWalletTypeCode = parseFloat(element[7] as string);
            if (isNaN(invoiceWalletTypeCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna H. El tipo de cartera no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            } else if (invoiceWalletTypeCode < 1 || invoiceWalletTypeCode > 4) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna H. El tipo de cartera debe ser un valor entre 1 y 4.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            // I. Documento Cliente:
            clientDocument = element[8] as string;
            if (clientDocument == null) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna I. El documento del cliente no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            } else if (clientDocument.length > 15) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna I. El documento del cliente supera el tamaño máximo de caracteres (15)`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            // J. Documento2 Cliente:
            clientDocument2 = element[9] as string;
            if (clientDocument2 != null && clientDocument2.length > 15) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna J. El documento 2 del cliente supera el tamaño máximo de caracteres (15).`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //K. Código C.Costos:
            if (element[10] as string != null) {
              costCenterCode = parseFloat(element[10] as string);
              if (isNaN(costCenterCode)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna K. El código del centro de costos no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }
            } else {
              costCenterCode = null;
            }

            //L. Documento vendedor:
            sellerDocument = element[11] as string;
            if (sellerDocument == null) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna L. El documento del vendedor no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            } else if (sellerDocument.length > 15) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna L. El documento del vendedor supera el tamaño máximo de caracteres (15)`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //M. Cufe:
            cufe = element[12] as string;
            if (cufe != null && cufe.length > 99) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna M. El cufe supera el tamaño máximo de caracteres (99).`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //N. Autoretenedor Fuente
            if (element[13] as string != "S" && element[13] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna N. El campo autoretenedor fuente debe ser valores como: S / N.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }
            swSelfRetainer = element[13] as string === "S";

            //O. Autoretenedor ICA
            if (element[14] as string != "S" && element[14] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna O. El campo autoretenedor ica debe ser valores como: S / N.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }
            swIcaSelfRetainer = element[14] as string === "S";

            //P. Valor Subtotal:
            subtotalValue = parseFloat(element[15] as string);
            if (isNaN(subtotalValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna P. El valor subtotal no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //Q. Valor Descuento General:
            discountValue = parseFloat(element[16] as string);
            if (isNaN(discountValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna Q, Fila ${counter}. El valor descuento general no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //R. Valor IVA:
            ivaValue = parseFloat(element[17] as string);
            if (isNaN(ivaValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna R. El valor iva no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //S. Valor total:
            totalValue = parseFloat(element[18] as string);
            if (isNaN(totalValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna S. El valor total no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //T. Valor reteiva:
            reteIvaValue = parseFloat(element[19] as string);
            if (isNaN(reteIvaValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna T. El valor reteiva no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //U. Valor retefuente:
            reteFuenteValue = parseFloat(element[20] as string);
            if (isNaN(reteFuenteValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna U. El valor retefuente no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //V. Valor reteica:
            reteIcaValue = parseFloat(element[21] as string);
            if (isNaN(reteIcaValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna V. El valor reteica no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //W. Valor a Pagar:
            valueToPay = parseFloat(element[22] as string);
            if (isNaN(valueToPay)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna W. El valor a pagar no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //X. Valor de Abonos:
            paymentValue = parseFloat(element[23] as string);
            if (isNaN(paymentValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna X. El valor de abonos no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //Y. Valor de Notas debito:
            debitNotesValue = parseFloat(element[24] as string);
            if (isNaN(debitNotesValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna Y. El valor de notas débito no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //Z. Valor de Notas credito:
            creditNotesValue = parseFloat(element[25] as string);
            if (isNaN(creditNotesValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna Z. El valor de notas crédito no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //AA. Valor del Saldo:
            residueValue = parseFloat(element[26] as string);
            if (isNaN(residueValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna AA. El valor del saldo no es válido.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }

            //AB. Actualizar detalles
            if (element[27] as string != "S" && element[27] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna AB. El campo actualizar detalles y conceptos debe ser valores como: S / N.`;
              this.invoiceAlerts.push(alert);
              rowHasError = true;
            }
            updateDetails = element[27] as string === "S";

            if (updateDetails) {
              //AC. Concepto Fra:
              conceptInvoicingCode = parseFloat(element[28] as string);
              if (isNaN(conceptInvoicingCode)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AC. El código del concepto de facturación no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AD. Bodega:
              storeCode = parseFloat(element[29] as string);
              if (isNaN(storeCode)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AD. El código de la bodega no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AE. Valor Concepto :
              valueConcept = parseFloat(element[30] as string);
              if (isNaN(valueConcept)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AE. El valor concepto no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AF. Valor iva Concepto :
              ivaValueConcept = parseFloat(element[31] as string);
              if (isNaN(ivaValueConcept)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AF. El valor iva concepto no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AG. Valor retefuente Concepto :
              reteFuenteValueConcept = parseFloat(element[32] as string);
              if (isNaN(reteFuenteValueConcept)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AG. El valor retefuente concepto no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AH. Valor reteica Concepto :
              reteIcaValueConcept = parseFloat(element[33] as string);
              if (isNaN(reteIcaValueConcept)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AH. El valor reteica concepto no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AI. Valor descuento Concepto :
              discountValueConcept = parseFloat(element[34] as string);
              if (isNaN(discountValueConcept)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AI. El valor descuento concepto no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AJ. Valor notas débito Concepto :
              debitNotesValueConcept = parseFloat(element[35] as string);
              if (isNaN(debitNotesValueConcept)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AJ. El valor notas débito concepto no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AK. Valor notas crédito Concepto :
              creditNotesValueConcept = parseFloat(element[36] as string);
              if (isNaN(creditNotesValueConcept)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AK. El valor notas crédito concepto no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AL. Fecha PDF:
              const dateInvoicePdfString = element[37] as string;
              if (dateInvoicePdfString == null || dateInvoicePdfString == "") {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AL. El campo de fecha Pdf es obligatorio.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }
              //Convierte fecha de string a Date
              dateInvoicePdf = moment(dateInvoicePdfString, 'DD/MM/YYYY').toDate();

              if (!moment(dateInvoicePdfString, 'DD/MM/YYYY').isValid()) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AL. El campo de fecha Pdf no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }

              //AM. Fecha Envio:
              const dateInvoiceSendString = element[38] as string;
              if (dateInvoiceSendString == null || dateInvoiceSendString == "") {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AM. El campo de fecha Envio es obligatorio.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }
              //Convierte fecha de string a Date
              dateInvoiceSend = moment(dateInvoiceSendString, 'DD/MM/YYYY').toDate();

              if (!moment(dateInvoiceSendString, 'DD/MM/YYYY').isValid()) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna AM. El campo de fecha Envio no es válido.`;
                this.invoiceAlerts.push(alert);
                rowHasError = true;
              }
            } else {
              conceptInvoicingCode = null;
              storeCode = null;
              valueConcept = null;
              ivaValueConcept = null;
              reteFuenteValueConcept = null;
              reteIcaValueConcept = null;
              discountValueConcept = null;
              debitNotesValueConcept = null;
              creditNotesValueConcept = null;
            }

            if (!rowHasError) {
              row = new InvoiceImportModel(counter, this.companyId!, this.branchId, this.enterpriseId, bussinessDocumentsClassId, bussinessDocumentsTypeCode,
                invoiceConsecutive, dateInvoice, dateExpiration, invoiceWalletTypeCode, clientDocument, clientDocument2, costCenterCode, sellerDocument, cufe, swSelfRetainer, swIcaSelfRetainer, subtotalValue, discountValue,
                ivaValue, totalValue, reteIvaValue, reteFuenteValue, reteIcaValue, valueToPay, paymentValue, debitNotesValue, creditNotesValue, residueValue, updateDetails,
                conceptInvoicingCode, storeCode, valueConcept, ivaValueConcept, reteFuenteValueConcept, reteIcaValueConcept, discountValueConcept, debitNotesValueConcept, creditNotesValueConcept, articleId, updateInvoicesZero, dateInvoicePdf, dateInvoiceSend);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.invoiceService.importInvoice(rowsImports));
              this.loadPreInvoicingModel = response;
              this.invoiceAlerts = response?.alerts ?? [];
              this.errorInvoice = response?.preInvoicingStateId;

              if (this.errorInvoice === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.invoiceAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con alertas, puede exportarlas si lo desea.'
                );
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast(
                  'success',
                  `La importación terminó exitosamente.`
                );
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar Facturas.', error);
            }
          } else {
            this.errorInvoice = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No ha seleccionado ningún archivo.'
        });
      }
    } else {
      this.showValidationMessages();
    }
  }

  openToggle(event: any) {
    this.informationPopover.toggle(event);
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatiria.',
      },
      branchId: {
        required: 'La sucursal es obligatoria.',
        min: 'La sucursal es obligatoria.'
      },
      enterpriseId: {
        required: 'La empresa es obligatoria.',
        min: 'La empresa es obligatoria.'
      },
      bussinessDocumentsClassId: {
        required: 'La clase es obligatoria.',
        min: 'La clase es obligatoria.'
      },
      articleId: {
        required: 'El artículo es obligatorio.',
        min: 'El artículo es obligatorio.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      enterpriseId: [0, [Validators.required, Validators.min(1)]],
      bussinessDocumentsClassId: [1, [Validators.required]],
      articleId: [0, [Validators.required, Validators.min(1)]],
      updateInvoicesZero: [false, []]
    });
  }

}
